import { bunja } from 'bunja';
import { atom } from 'jotai';

import { LaunchpoolStatus } from '@flipster/apis/v1/launchpool/types';
import { launchpoolItemBunja } from '@flipster/features/src/shared/launchpool/state';
import { isSameUTCYear } from '@flipster/utils/datetime';

export const sparkLaunchpoolItemBunja = bunja(() => {
  const { launchpoolItemAtom } = bunja.use(launchpoolItemBunja);
  const isClosedAtom = atom((get) => {
    const sparkLaunchpool = get(launchpoolItemAtom);
    return sparkLaunchpool.status === LaunchpoolStatus.Closed;
  });

  const isUpcomingAtom = atom((get) => {
    const sparkLaunchpool = get(launchpoolItemAtom);
    return sparkLaunchpool.status === LaunchpoolStatus.Upcoming;
  });

  const isOngoingAtom = atom((get) => {
    const sparkLaunchpool = get(launchpoolItemAtom);
    return sparkLaunchpool.status === LaunchpoolStatus.Ongoing;
  });

  const isStakableAtom = atom((get) => {
    const sparkLaunchpool = get(launchpoolItemAtom);
    return sparkLaunchpool.isStakable;
  });

  const isSameYearAtom = atom((get) => {
    const { startAt, endAt } = get(launchpoolItemAtom);
    return isSameUTCYear(startAt, endAt);
  });

  const rewardCurrencyPrecision = 2; // https://prex.atlassian.net/browse/QA-6017
  const stakingCurrencyPrecision = undefined;

  return {
    launchpoolItemAtom,
    isClosedAtom,
    isUpcomingAtom,
    isOngoingAtom,
    isStakableAtom,
    isSameYearAtom,
    rewardCurrencyPrecision,
    stakingCurrencyPrecision,
  };
});
